var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_28",
    "data-name": "Group 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101.692,
    height: 101.692,
    viewBox: "0 0 101.692 101.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "profile-img-clip"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 101.692,
    height: 101.692,
    fill: "#393939"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    clipPath: "url(#profile-img-clip)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M86.8,14.893A50.846,50.846,0,1,0,14.893,86.8,50.846,50.846,0,1,0,86.8,14.893M50.846,23.156A18.213,18.213,0,1,1,32.633,41.369,18.213,18.213,0,0,1,50.846,23.156M81.627,85.115a46,46,0,0,1-61.562,0V80.8A17.243,17.243,0,0,1,37.308,63.557H64.384A17.243,17.243,0,0,1,81.627,80.8Z",
    fill: "#393939"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg);
export default __webpack_public_path__ + "static/media/profile-img.b9b849f275858fdda62a14de0fd7a963.svg";
export { ForwardRef as ReactComponent };